import { createContext, type FC, type ReactElement, useState } from 'react';
import type { GlassWasherModel, GlassWasherSortingFields, Order } from '../models';

interface IGlassWashersContext {
  glassWashersUpdate: boolean;
  toggleUpdate: () => void;
  glassWashers: GlassWasherModel[];
  setGlassWashers: (val: GlassWasherModel[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: GlassWasherSortingFields;
  setOrderBy: (val: GlassWasherSortingFields) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const GlassWashersContext = createContext<IGlassWashersContext>({} as IGlassWashersContext);

export const GlassWashersProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [glassWashersUpdate, setGlassWashersUpdate] = useState(false);
  const [glassWashers, setGlassWashers] = useState<GlassWasherModel[]>([]);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [count, setCount] = useState<number>(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<GlassWasherSortingFields>('name');
  const [loading, setLoading] = useState(false);
  const toggleUpdate = (): void => setGlassWashersUpdate(!glassWashersUpdate);

  return (
    <GlassWashersContext.Provider
      value={{
        glassWashersUpdate,
        toggleUpdate: toggleUpdate,
        glassWashers,
        setGlassWashers,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        loading,
        setLoading
      }}
    >
      {children}
    </GlassWashersContext.Provider>
  );
};

export class GlassWasherContext {}
